import React from "react";
import styles from "./style.module.scss";
import TimingDataManager from "../../components/DataManagers/TimingDataManager";
import AuthenticatedLayout from "../../components/Layout/authenticatedLayout";
import ImportsDataManager from "../../components/DataManagers/ImportsDataManager";
import RaceDataDataManager from "../../components/DataManagers/RaceDataDataManager";
import RaceDataContainer from "../../components/RaceData/RaceDataContainer";

function RaceDataPage() {
  return (
    <AuthenticatedLayout title={"Race Data"} showJaguarLogo={false}>
      <TimingDataManager />
      <ImportsDataManager />
      <RaceDataDataManager />
      <div className={styles.container}>
        <RaceDataContainer />
      </div>
    </AuthenticatedLayout>
  );
}

export default RaceDataPage;
